export default __webpack_public_path__ + "static/media/huaweiB.4b4007dc.jpg";